import { CommonModule } from "@angular/common";
import { Component, Input, forwardRef } from "@angular/core";
import {
    ControlValueAccessor,
    FormsModule,
    NG_VALUE_ACCESSOR
} from "@angular/forms";

@Component({
    selector: "dsn-textarea",
    standalone: true,
    imports: [CommonModule, FormsModule],
    templateUrl: "./textarea.component.html",
    styleUrl: "./textarea.component.scss",
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TextareaComponent),
            multi: true
        }
    ]
})
export class TextareaComponent implements ControlValueAccessor {
    @Input() placeholder: string = "";
    @Input() disabled: boolean = false;
    @Input() isInvalid?: boolean;
    @Input() invalidMessage?: string;
    @Input() rows: number = 3;
    @Input() cols: number = 30;

    private _value: string = "";
    private onChange: (value: string) => void = () => {};
    private onTouched: () => void = () => {};

    get value(): string {
        return this._value;
    }

    set value(val: string) {
        this._value = val;
        this.onChange(val);
        this.onTouched();
    }

    writeValue(value: string): void {
        this._value = value;
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
}
